import React from 'react';
import { IconProps } from './types';

const ArrowLeft: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181B32',
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size * 1.166666667}
    height={size}
    viewBox="0 0 14 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      fillRule="evenodd"
      d="M14 6a1 1 0 00-1-1H3a1 1 0 100 2h10a1 1 0 001-1z"
      clipRule="evenodd"
    />
    <path
      fill={!ignoreColor ? color : undefined}
      fillRule="evenodd"
      d="M8.067.3A1 1 0 006.653.286L.603 6.229l6.079 5.512a1 1 0 001.343-1.482L3.516 6.171l4.538-4.458A1 1 0 008.067.3z"
      clipRule="evenodd"
    />
  </svg>
);

export default ArrowLeft;
